import { Component, Input, OnInit } from '@angular/core';
import { QRCodeElementType, QRCodeModule } from 'angularx-qrcode';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'qrcode-modal',
  template: ` <div class="modal-bloc" *transloco="let t">
    <p>{{ 'no_ra_title' | transloco }}</p>
    <p>{{ 'no_ra_body' | transloco }}</p>

    <div class="qrcode">
      <qrcode
        *ngIf="data"
        [qrdata]="data!"
        [width]="256"
        [errorCorrectionLevel]="'M'"
        [elementType]="type!"
      ></qrcode>
    </div>
  </div>`,
  styles: `.modal-bloc{
    margin: .6rem;
    p {
      justify-content: center;
      display: flex;
    }
  }
  qrcode {
    text-align: center;
    
  }
  .btn-close {
    right: 0;
  }`,
  standalone: true,
  imports: [CommonModule, QRCodeModule, TranslocoModule],
})
export class QrcodeModalComponent implements OnInit {
  @Input() public type?: QRCodeElementType;
  @Input() public data?: string;

  constructor() {}

  ngOnInit(): void {
    if (this.data === undefined) {
      throw new Error('Empty data');
    }
    if (this.type === undefined) {
      throw new Error('Unknown type');
    }
  }
}
